export const UPDATE_PLAN = 'app/PlansPage/UPDATE_PLAN';
export const GET_PLAN = 'app/PlansPage/GET_PLAN';
